// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"#1890ff","pageTab":"#42b983","menuBg":"#304156","menuSubBg":"#1F2D3D","menuBgHover":"#263445","menuSubBgHover":"#001528","menuFont":"#BFCBD9","menuLogo":"#2B2F3A"};